import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ModalModule } from "ngx-bootstrap/modal";
import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

import { SalesManagerShopItemsComponent } from "./salesmanagershopitems.component";
import { SalesManagerShopItemsService, SalesManagerShopItemConfigService, ISalesManagerShopItemConfigService } from "./salesmanagershopitems.service";
import { SalesManagerShopItemDetailComponent } from "./salesmanagershopitemdetail.component";
import { TranslateModule } from "@ngx-translate/core";
import { OAuthModule } from "@impacgroup/angular-oauth-base";
import { Route, RouterModule } from "@angular/router";
import { SalesManagerShopItemsMainComponent } from "./salesmanagershopitems.main.component";

@NgModule({
    declarations: [SalesManagerShopItemsMainComponent, SalesManagerShopItemsComponent, SalesManagerShopItemDetailComponent],
    imports: [CommonModule, RouterModule, FormsModule, BsDropdownModule, ModalModule, NgSelectModule, TranslateModule, OAuthModule, ReactiveFormsModule, MatTableModule, MatPaginatorModule, MatSortModule, MatFormFieldModule, MatInputModule],
    exports: [],
    providers: []
})
export class SalesManagerShopItemsModule {
    static forRoot(salesManagerShopItemConfig: ISalesManagerShopItemConfigService): ModuleWithProviders<SalesManagerShopItemsModule> {
        // returns the services as singletons throughout the app (for lazy loading purposes)
        return {
            ngModule: SalesManagerShopItemsModule,
            providers: [
                SalesManagerShopItemsService,
                {
                    provide: SalesManagerShopItemConfigService,
                    useValue: salesManagerShopItemConfig
                }
            ]
        };
    }

    static getRoutes(): Route[] {
        return [
            {
                path: "",
                component: SalesManagerShopItemsMainComponent,
                children: [
                    {
                        path: "",
                        component: SalesManagerShopItemsComponent
                    },
                    {
                        path: "add",
                        component: SalesManagerShopItemDetailComponent
                    },
                    {
                        path: ":id",
                        component: SalesManagerShopItemDetailComponent
                    }
                ]
            }
        ];
    }
}
